function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-1",
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.18,39.07a3,3,0,0,1-2.53-1.42,2.88,2.88,0,0,1-.4-1.54V22.05a1.53,1.53,0,0,0-.52-1.15,1.49,1.49,0,0,0-1.19-.39,1.62,1.62,0,0,0-1.39,1.65V36a2.91,2.91,0,0,1-3.75,2.89A19.83,19.83,0,0,1,15.82.4,18.8,18.8,0,0,1,23.18.33,19.76,19.76,0,0,1,37.88,12h0A19.85,19.85,0,0,1,25,39,2.62,2.62,0,0,1,24.18,39.07ZM19.69,18.85a3.2,3.2,0,0,1,3.2,3.2h0V36.13a1.29,1.29,0,0,0,1.29,1.29,1.34,1.34,0,0,0,.35-.05A18.16,18.16,0,0,0,37.22,15a18.37,18.37,0,0,0-.83-2.36h0A18.14,18.14,0,0,0,22.88,2a17.37,17.37,0,0,0-6.74,0,18.18,18.18,0,0,0-1.26,35.37A1.31,1.31,0,0,0,16,37.15a1.28,1.28,0,0,0,.51-1v-14a3.29,3.29,0,0,1,2.87-3.29Zm.07-2.26a3.09,3.09,0,0,1-1-.17A3.25,3.25,0,1,1,21.65,16h0A3.26,3.26,0,0,1,19.76,16.59Zm0-4.86a1.6,1.6,0,0,0-1.54,2.08,1.6,1.6,0,0,0,2,1.06,1.58,1.58,0,0,0,.47-.23,1.57,1.57,0,0,0-.41-2.78A1.42,1.42,0,0,0,19.76,11.73Z"
}))));

var SvgIternalLogoSymbol = function SvgIternalLogoSymbol(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39.52 39.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIternalLogoSymbol, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iternal_logo_symbol.f3c146ed.svg";
export { ForwardRef as ReactComponent };